import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.emailBCCSettings.title',
    defaultMessage: 'Email BCC',
    description: 'title of the email bcc settings on the configuration page',
  },
  subtitle: {
    id: 'pages.settings.general.emailBCCSettings.subtitle',
    defaultMessage: 'Send blind copies of notification emails to these addresses',
    description: 'subtitle of the email bcc settings on the configuration page',
  },
  feedback: {
    emailBCCSettingsUpdated: {
      id: 'pages.settings.general.emailBCCSettings.feedback.emailBCCSettingsUpdated',
      defaultMessage: 'Email BCC settings saved',
      description: 'feedback on the successful update of email bcc settings',
    },
    emailBCCSettingsNotUpdated: {
      id: 'pages.settings.general.emailBCCSettings.feedback.emailBCCSettingsNotUpdated',
      defaultMessage: 'Email BCC settings could not be saved',
      description: 'feedback on the failed update of email bcc settings',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.emailBCCSettings.editDrawer.title',
      defaultMessage: 'Edit email BCC',
      description: 'title of the edit bcc email settings drawer',
    },
    bccField: {
      label: {
        id: 'properties.addresses',
        defaultMessage: 'Addresses',
        description: 'label of the bcc field',
      },
    },
    emailField: {
      label: {
        id: 'properties.email',
        defaultMessage: 'Email',
        description: 'label of the email field',
      },
    },
    nameField: {
      label: {
        id: 'properties.name',
        defaultMessage: 'Name',
        description: 'label of the name field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
